/**
 * Derives a display filename from a URL's last path segment, stripping any
 * query string (e.g. presigned-S3 signature params) and percent-decoding it.
 * Falls back to `fallbackName` when the URL has no usable segment.
 */
export function filenameFromUrl(url: string, fallbackName: string): string {
  return decodeURIComponent(
    url.split('/').pop()?.split('?')[0] ?? fallbackName,
  );
}

export function triggerDownload(url: string, fallbackName = 'output.msh') {
  const link = document.createElement('a');
  link.href = url;
  link.download = filenameFromUrl(url, fallbackName);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoked on the next frame rather than in the same tick as the click:
  // Safari cancels an in-flight download whose object URL is revoked
  // synchronously, which loses the file with no error anywhere.
  requestAnimationFrame(() => URL.revokeObjectURL(url));
}
